import { useConfigSlice } from '../store/slices/config/selectors';

// TODO: Crash games should fall-back to hiding Lobby for undefined configs. Pass a flag to differentiate a "game type".

export const isLobbyButtonHidden = (tableConfig: boolean | undefined, casinoConfig: boolean | undefined): boolean => {
  // Table config level is final and overrides casino config. Fall-back to displaying Lobby for undefined configs.
  return Boolean(tableConfig ?? casinoConfig);
};

export const useIsLobbyButtonHiddenConnected = (): boolean => {
  const isLobbyButtonHiddenTableConfig = useConfigSlice.tableConfig()?.hideLobby;
  const isLobbyButtonHiddenCasinoConfig = useConfigSlice.casinoConfig()?.hideLobbyButtons;

  return isLobbyButtonHidden(isLobbyButtonHiddenTableConfig, isLobbyButtonHiddenCasinoConfig);
};
